import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push
// lvxiaofeng: 重写原型上的push方法，统一处理错误信息vue-router.esm.js:2046 Uncaught (in promise) NavigationDuplicated
VueRouter.prototype.push = function push(location) {
	return originalPush.call(this, location).catch(err => err)
}

let routes = [ 
	{
		// will match everything
		path: '*',
		component: () => import('../views/404.vue'),
	},
	{
		path: '/bj/:name/:key',
		component: () => import('../views/supper_quotation/supper_quotation.vue'),
	},
	{
		path: '/',
		name: 'Home',
		redirect: '/notification',
	},
	// {
	// 	path: '/',
	// 	name: 'Home',
	// 	redirect: '/purchase/materials',
	// },
	// {
	// 	path: '/',
	// 	name: 'home',
	// 	redirect: '/dashboard',
	// },
	{
		path: '/index',
		name: '纵览',
		layout: "dashboard", 
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () => import(/* webpackChunkName: "dashboard" */ '../views/Index.vue'),
	},
	{
		path: '/notification',
		name: '消息中心',
		layout: "dashboard",
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () => import(/* webpackChunkName: "dashboard" */ '../views/NotificationCenter.vue'),
	},
	{
		path: '/personnel',
		name: '人事管理',
		layout: "dashboard",
		component: () => import('../views/Personnel.vue'),
	},
	{
		path: '/personnel/project/manage',
		name: '项目人员管理',
		layout: "dashboard",
		component: () => import('../views/personnel/project/Personal_manage.vue'),
	},
	{
		path: '/personnel/project/transfer',
		name: '项目人员调动',
		layout: "dashboard",
		component: () => import('../views/personnel/project/PersonalTransfer.vue'),
	},
	{
		path: '/personnel/attendance/form',
		name: '考勤统计',
		layout: "dashboard",
		component: () => import('../views/personnel/attendance/Form.vue'),
	},
	{
		path: '/personnel/attendance/detail',
		name: '个人详情',
		layout: "dashboard",
		component: () => import('../views/personnel/attendance/Detail.vue'),
	},
	{
		path: '/personnel/project/privileges',
		name: '权限管理',
		layout: "dashboard",
		component: () => import('../views/hr/Privileges.vue'),
	},
	{
		path: '/personnel/attendance/apply',
		name: '假勤管理',
		layout: "dashboard",
		component: () => import('../views/personnel/attendance/Apply.vue'),
	},
	{
		path: '/purchase',
		name: '物资申购单',
		layout: "dashboard",
		component: () => import('../views/purchase/PurchaseApply.vue'),
	},
	{
		path: '/purchase/bidding',
		name: '物资招标申请',
		layout: "dashboard",
		component: () => import('../views/purchase/PurchaseBidding.vue'),
	},
	{
		path: '/purchase/add',
		name: '项目申购',
		layout: "dashboard",
		component: () => import('../views/purchase/AddPurchaseApply.vue'),
	},
	{
		path: '/purchase/supplier_link',
		name: '供应商报价链接表',
		layout: "dashboard",
		component: () => import('../views/purchase/PurchaseSupplierLinkList.vue'),
	},
	{
		path: '/purchase/record',
		name: '采购记录',
		layout: "dashboard",
		component: () => import('../views/purchase/Purchase_record.vue'),
	},
	{
		path: '/purchase/report',
		name: '物资申请表',
		layout: "dashboard",
		component: () => import('../views/purchase/Report.vue'),
	},
	{
		path: '/purchase/report/table',
		name: '物资申请表',
		layout: "dashboard",
		component: () => import('../views/purchase/report_table/table.vue'),
	},
	{
		path: '/purchase/test',
		name: '测试网页',
		layout: "dashboard",
		component: () => import('../views/purchase/supplier_list/Suppliers_list.vue'),
	},
	{
		path: '/purchase/materials',
		name: '物资列表',
		layout: "dashboard",
		component: () => import('../views/purchase/Materials.vue'),
	},
	{
		path: '/purchase/inventory',
		name: '材料库存表',
		layout: "dashboard",
		component: () => import('../views/purchase/Inventory.vue'),
	},
	{
		path: '/purchase/suppliers',
		name: '供应商列表',
		layout: "dashboard",
		component: () => import('../views/purchase/Suppliers.vue'),
	},
	{
		path: '/purchase/suppliers/record',
		name: '物资申购记录',
		layout: "dashboard",
		component: () => import('../views/purchase/supplier_list/Suppliers_record.vue'),
	},
	{
		path: '/purchase/capital_assets',
		name: '固定资产统计表',
		layout: "dashboard",
		component: () => import('../views/purchase/Capital.vue'),
	},
	{
		path: '/purchase/forms',
		name: '报表',
		layout: "dashboard",
		component: () => import('../views/purchase/forms/Forms.vue'),
	},
	{
		path: '/purchase/forms/instorage',
		name: '入库记录',
		layout: "dashboard",
		component: () => import('../views/purchase/forms/inStorage/Instorage.vue'),
	},
	{
		path: '/purchase/suppliers/detail',
		name: '供应商信息',
		layout: "dashboard",
		component: () => import('../views/purchase/supplier_list/Supplier_detail.vue'),
	},
	{
		path: '/purchase/forms/scrap/list',
		name: '物资报废表',
		layout: "dashboard",
		component: () => import('../views/purchase/forms/scrap/List.vue'),
	},
	{
		path: '/purchase/forms/scrap/detail',
		name: '物资报废',
		layout: "dashboard",
		component: () => import('../views/purchase/forms/scrap/Detail.vue'),
	},
	{
		path: '/purchase/transport',
		name: '物资调运',
		layout: "dashboard",
		component: () => import('../views/purchase/Transport.vue'),
	},
	{
		path: '/purchase/machinery_rental_apply',
		name: '机械租赁申请',
		layout: "dashboard",
		component: () => import('../views/purchase/MachineryRentalApply.vue'),
	},
	{
		path: '/purchase/machinery_rental',
		name: '机械租赁',
		layout: "dashboard",
		component: () => import('../views/purchase/MachineryRental.vue'),
	},
	{
		path: '/purchase/scrap_sale',
		name: '废料出售',
		layout: "dashboard",
		component: () => import('../views/purchase/ScrapSale.vue'),
	},
	{
		path: '/manage/part_b/contact',
		name: '进项合同',
		layout: "dashboard",
		component: () => import('../views/manage/part_b/ContactManage.vue'),
	},
	{
		path: '/finance',
		name: '财务',
		layout: "dashboard",
		component: () => import('../views/Finance.vue'),
	},
	{
		path: '/finance/reimburse',
		name: '个人报销',
		layout: "dashboard",
		component: () => import('../views/finance/Reimburse.vue'),
	},
	{
		path: '/finance/applypay',
		name: '付款申请',
		layout: "dashboard",
		component: () => import('../views/finance/ApplyPayment.vue'),
	},
	{
		path: '/finance/summary_form',
		name: '项目汇总表',
		layout: "dashboard",
		component: () => import('../views/finance/FinanceForm.vue'),
	},
	{
		path: '/finance/proceeds',
		name: '项目收入',
		layout: "dashboard",
		component: () => import('../views/finance/Proceeds.vue'),
	},
	{
		path: '/finance/expend',
		name: '项目支付',
		layout: "dashboard",
		component: () => import('../views/finance/Expend.vue'),
	},
	{
		path: '/finance/settle',
		name: '项目结算',
		layout: "dashboard",
		component: () => import('../views/finance/Settle.vue'),
	},
	{
		path: '/serve_fee',
		name: '招待费用申请',
		layout: "dashboard",
		component: () => import('../views/finance/ServeFee.vue'),
	},
	{
		path: '/serve_fee_summary',
		name: '招待费用汇总',
		layout: "dashboard",
		component: () => import('../views/finance/ServeFeeSummary.vue'),
	},
	{
		path: '/serve_fee_summary/detail',
		name: '招待费用明细',
		layout: "dashboard",
		component: () => import('../views/finance/ServeFeeDetail.vue'),
	},
	{
		path: '/finance/in_storage',
		name: '入库统计表',
		layout: "dashboard",
		component: () => import('../views/finance/InStorageForm.vue'),
	},
	{
		path: '/finance/out_storage',
		name: '出库统计表',
		layout: "dashboard",
		component: () => import('../views/finance/OutStorageForm.vue'),
	},
	{
		path: '/finance/transport_sum',
		name: '物资调运统计表',
		layout: "dashboard",
		component: () => import('../views/finance/TransportSum.vue'),
	},
	{
		path: '/finance/scrap_sum',
		name: '物资报废统计表',
		layout: "dashboard",
		component: () => import('../views/finance/ScrapSum.vue'),
	},
	{
		path: '/finance/scrap_sale_sum',
		name: '废料出售统计表',
		layout: "dashboard",
		component: () => import('../views/finance/ScrapSaleSum.vue'),
	},
	{ 
		path: '/finance/purchase_history',
		name: '物资申购记录',
		layout: "dashboard",
		component: () => import('../views/finance/PurchaseHistory.vue'),
	}, 
	{
		path: '/finance/inventory_sum',
		name: '材料库存统计表',
		layout: "dashboard",
		component: () => import('../views/finance/InventorySum.vue'),
	},
	{
		path: '/finance/payment',
		name: '付款申请',
		layout: "dashboard",
		component: () => import('../views/finance/PaymentApply.vue'),
	},
	{
		path: '/finance/summary',
		name: '汇总明细统计表',
		layout: "dashboard",
		component: () => import('../views/finance/Summary.vue'),
	},
	{
		path: '/legal',
		name: '法务',
		layout: "dashboard",
		component: () => import('../views/Legal.vue'),
	},
	{
		path: '/legal/case_list',
		name: '诉讼案件汇总表',
		layout: "dashboard",
		component: () => import('../views/legal/CaseList.vue'),
	},
	{
		path: '/legal/lawyer_letter',
		name: '律师函汇总表',
		layout: "dashboard",
		component: () => import('../views/legal/LetterList.vue'),
	},
	{
		path: '/legal/labor',
		name: '劳动仲裁',
		layout: "dashboard",
		component: () => import('../views/legal/Labor.vue'),
	},
	{
		path: '/legal/injury',
		name: '工伤汇总',
		layout: "dashboard",
		component: () => import('../views/legal/WorkInjury.vue'),
	},
	{
		path: '/costManage',
		name: '成本管理',
		layout: "dashboard",
		component: () => import('../views/costManage/CostManage.vue'),
	},
	{
		path: '/costManage/manpower',
		name: '人工',
		layout: "dashboard",
		component: () => import('../views/costManage/Manpower.vue'),
	},
	{
		path: '/costManage/subpackage',
		name: '分包',
		layout: "dashboard",
		component: () => import('../views/costManage/Subpackage.vue'),
	},
	{
		path: '/costManage/settlement',
		name: '结算款',
		layout: "dashboard",
		component: () => import('../views/costManage/Settlement.vue'),
	},
	{
		path: '/costManage/team_contract',
		name: '班组合同',
		layout: "dashboard",
		component: () => import('../views/costManage/TeamContract.vue'),
	},
	{
		path: '/costManage/remetering',
		name: '重计量',
		layout: "dashboard",
		component: () => import('../views/costManage/Remetering.vue'),
	},
	{
		path: '/costManage/price_adjust',
		name: '调差',
		layout: "dashboard",
		component: () => import('../views/costManage/PriceAdjust.vue'),
	},
	{
		path: '/costManage/visa',
		name: '签证',
		layout: "dashboard",
		component: () => import('../views/costManage/Visa.vue'),
	},
	{
		path: '/costManage/owers_confirm',
		name: '业主确认单',
		layout: "dashboard",
		component: () => import('../views/costManage/owersConfirm.vue'),
	},
	{
		path: '/projectManage',
		name: '工程管理',
		layout: "dashboard",
		component: () => import('../views/projectManage.vue'),
	},
	{
		path: '/projectManage/project_fee',
		name: '项目经营费',
		layout: "dashboard",
		component: () => import('../views/projectManage/ProjectManageFee.vue'),
	},
	{
		path: '/projectManage/scheme_approval',
		name: '方案审批',
		layout: "dashboard",
		component: () => import('../views/projectManage/SchemeApproval.vue'),
	},
	{
		path: '/projectManage/schedule',
		name: '工程进度',
		layout: "dashboard",
		component: () => import('../views/projectManage/ProjectSchedule.vue'),
	},
	{
		path: '/projectManage/machine',
		name: '机械需求',
		layout: "dashboard",
		component: () => import('../views/projectManage/MachineApply.vue'),
	},
	{
		path: '/projectManage/employing',
		name: '零星用工',
		layout: "dashboard",
		component: () => import('../views/projectManage/EmployingApply.vue'),
	},
	{
		path: '/projectManage/employing_test',
		name: '零星用工测试版',
		layout: "dashboard",
		component: () => import('../views/projectManage/EmployingApplyTest.vue'),
	},
	{
		path: '/projectManage/bigmachine',
		name: '器械加班',
		layout: "dashboard",
		component: () => import('../views/projectManage/BigMachine.vue'),
	},
	{
		path: '/projectManage/distWork',
		name: '派工单',
		layout: "dashboard",
		component: () => import('../views/projectManage/DistWork.vue'),
	},
	{
		path: '/projects',
		name: '项目',
		layout: "dashboard",
		component: () => import('../views/company/Projects.vue'),
	},
	{
		path: '/documents',
		name: '公司文件',
		layout: "dashboard",
		component: () => import('../views/company/Documents.vue'),
	},
	{
		path: '/stamp',
		name: '用印申请',
		layout: "dashboard",
		component: () => import('../views/company/StampApply.vue'),
	},
	{
		path: '/clients',
		name: '甲方单位',
		layout: "dashboard",
		component: () => import('../views/company/Clients.vue'),
	},
	{
		path: '/template',
		name: '模版管理',
		layout: "dashboard",
		component: () => import('../views/company/TemplateManage.vue'),
	},
	{
		path: '/purchase/transport',
		name: '物资转运',
		layout: "dashboard",
		component: () => import('../views/purchase/Transport.vue'),
	},
	{
		path: '/hr/requirement',
		name: '人员需求',
		layout: "dashboard",
		component: () => import('../views/hr/Requirements.vue'),
	},
	{
		path: '/hr/dimission',
		name: '离职申请',
		layout: "dashboard",
		component: () => import('../views/hr/Dimission.vue'),
	},
	{
		path: '/hr/hire',
		name: '录用申请',
		layout: "dashboard",
		component: () => import('../views/hr/Hire.vue'),
	},
	{
		path: '/contract/inputcontract',
		name: '合同管理',
		layout: "dashboard",
		component: () => import('../views/contract/InputContract.vue'),
	},
	{
		path: '/contract/contract',
		name: '进项合同',
		layout: "dashboard",
		component: () => import('../views/contract/Contract.vue'),
	},
	{
		path: '/contract/clients',
		name: '甲方合同',
		layout: "dashboard",
		component: () => import('../views/contract/Clients.vue'),
	},
	{
		path: '/dashboard',
		name: 'Dashboard',
		layout: "dashboard",
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () => import(/* webpackChunkName: "dashboard" */ '../views/Dashboard.vue'),
	},
	// {
	// 	path: '/layout',
	// 	name: 'Layout',
	// 	layout: "dashboard",
	// 	component: () => import('../views/Layout.vue'),
	// },
	// {
	// 	path: '/tables',
	// 	name: 'Tables',
	// 	layout: "dashboard",
	// 	component: () => import('../views/Tables.vue'),
	// },
	// {
	// 	path: '/billing',
	// 	name: 'Billing',
	// 	layout: "dashboard",
	// 	component: () => import('../views/Billing.vue'),
	// },
	{
		path: '/rtl',
		name: 'RTL',
		component: () => import('../views/RTL.vue'),
	},
	{
		path: '/Profile',
		name: 'Profile',
		layout: "dashboard",
		meta: {
			layoutClass: 'layout-profile',
		},
		component: () => import('../views/Profile.vue'),
	},
	{
		path: '/Privacy',
		name: 'Privacy',
		component: () => import('../views/Privacy.vue'),
	},
	{
		path: '/sign-in',
		name: 'Sign-In',
		component: () => import('../views/Sign-In.vue'),
	},
	{
		path: '/sign-up',
		name: 'Sign-Up',
		meta: {
			layoutClass: 'layout-sign-up',
		},
		component: () => import('../views/Sign-Up.vue'),
	},
	{
		path: '/phone-manage',
		name: 'Phone-Manage',
		component: () => import('../views/phoneManage.vue'),
	},
	

	{
		path: '/tool_agreement',
		name: '超级工具汇软件隐私政策',
		meta: { title: '工具汇用户协议' }, // 定义页面标题
		component: () => import('../views/agreement/ToolAgree.vue'),
	},
	{
		path: '/tool_privacy',
		name: '超级工具汇软件隐私政策',
		meta: { title: '工具汇隐私政策' }, // 定义页面标题
		component: () => import('../views/privacy/ToolPrivacy.vue'),
	},
	{
		path: '/star_agreement',
		name: '星辰交友用户协议',
		meta: { title: '星辰交友用户协议' }, // 定义页面标题
		component: () => import('../views/agreement/StarAgree.vue'),
	},
	{
		path: '/star_privacy',
		name: '星辰交友隐私政策',
		meta: { title: '星辰交友隐私政策' }, // 定义页面标题
		component: () => import('../views/privacy/StarPrivacy.vue'),
	},


]

// Adding layout property from each route to the meta
// object so it can be accessed later.
function addLayoutToRoute( route, parentLayout = "default" )
{
	route.meta = route.meta || {} ;
	route.meta.layout = route.layout || parentLayout ;
	
	if( route.children )
	{
		route.children = route.children.map( ( childRoute ) => addLayoutToRoute( childRoute, route.meta.layout ) ) ;
	}
	return route ;
}

routes = routes.map( ( route ) => addLayoutToRoute( route ) ) ;

const router = new VueRouter({
	mode: 'hash',
	base: process.env.BASE_URL,
	routes,
	scrollBehavior (to, from, savedPosition) {
		if ( to.hash ) {
			return {
				selector: to.hash,
				behavior: 'smooth',
			}
		}
		return {
			x: 0,
			y: 0,
			behavior: 'smooth',
		}
	}
})

router.beforeEach((to, from, next) => {
	if(to.meta.title){
		document.title = to.meta.title;
	}
    next();
});


export default router
